import { render, staticRenderFns } from "./phoneNumber.vue?vue&type=template&id=40ca4d24&"
import script from "./phoneNumber.vue?vue&type=script&lang=ts&"
export * from "./phoneNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports